import { render } from "./SubmissionsList.vue?vue&type=template&id=3da02b6a&scoped=true"
import script from "./SubmissionsList.vue?vue&type=script&lang=js"
export * from "./SubmissionsList.vue?vue&type=script&lang=js"

import "./SubmissionsList.vue?vue&type=style&index=0&id=3da02b6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da02b6a"]])

export default __exports__